import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { useAppStore } from 'app_alegra_commons/app'


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalWebComponents',
  setup(__props) {

const APP = useAppStore()

const appVersion = computed((): string => APP.appVersion)

return (_ctx: any,_cache: any) => {
  const _component_smile_wc_mandate_signature = _resolveComponent("smile-wc-mandate-signature")!
  const _component_smile_wc_manifest_signature = _resolveComponent("smile-wc-manifest-signature")!

  return (_openBlock(), _createElementBlock("div", null, [
    (appVersion.value == 'colombia')
      ? (_openBlock(), _createBlock(_component_smile_wc_mandate_signature, { key: 0 }))
      : _createCommentVNode("", true),
    (appVersion.value == 'mexico')
      ? (_openBlock(), _createBlock(_component_smile_wc_manifest_signature, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})